import { createQueryKeys } from '@lukemorales/query-key-factory';

export const b2b = createQueryKeys('b2b', {
  workspace: null,
  members: null,
  invites: null,
  joinRequests: null,
  releaseRequests: null,
  billing: null,
  join: (token: string) => [token],
  adminReleases: null,
  setupLink: (token: string) => [token],
  adminList: (filters: Record<string, string>) => [filters],
  adminDetail: (agencyId: string) => [agencyId],
  adminAudit: (agencyId: string) => [agencyId],
});
